module.exports = __webpack_public_path__ + "public/img/vf.2c7d04d9.png";